import * as React from 'react';
import { IconProps } from '../types';

const IcClockIn = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M21.5 3H9.286v1.708h10.736v14.584H9.286V21H21.5V3ZM7.763 6.59 3.5 11.765l4.263 5.174 1.523-1.41-2.524-2.675h9.425v-2.03H6.764L9.184 8l-1.42-1.41Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcClockIn;
